<div class="row">
	<div class="col-xs-12 actions-col">
		<a href="/apps/{{appId}}/code-groups/new"><button class="button wide add">{{t "common.add"}}</button></a>
	</div>
</div>
<div class="app-error" id="noItems" style="display:none;">{{t "arpro.noitems"}}</div>

<table style="display:none;">
	<thead>
		<tr>
			<th>{{t "arpro.codeGroup.name"}}</th>
			<th>{{t "arpro.codeGroup.description"}}</th>
			<th>{{t "arpro.codeGroup.codes"}}</th>
			<th>{{t "common.tools"}}</th>
		</tr>
	</thead>
	<tbody class="list-items"></tbody>
</table>
